import { render, staticRenderFns } from "./ApptList.vue?vue&type=template&id=399d5e48&scoped=true"
import script from "./ApptList.vue?vue&type=script&lang=js"
export * from "./ApptList.vue?vue&type=script&lang=js"
import style0 from "./ApptList.vue?vue&type=style&index=0&id=399d5e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399d5e48",
  null
  
)

export default component.exports